module.exports = __webpack_public_path__ + "assets/img/title-19f2093e.png";